import SecondsWhite from "../images/customisation-assets/Seconds_White.png";
import SecondsAqua from "../images/customisation-assets/Seconds_Aqua.png";
import SecondsBlack from "../images/customisation-assets/Seconds_Black.png";
import SecondsBlue from "../images/customisation-assets/Seconds_Blue.png";
import SecondsBrown from "../images/customisation-assets/Seconds_Brown.png";
import SecondsLake from "../images/customisation-assets/Seconds_Lake.png";
import SecondsOrange from "../images/customisation-assets/Seconds_Orange.png";
import SecondsRed from "../images/customisation-assets/Seconds_Red.png";
import SecondsYellow from "../images/customisation-assets/Seconds_Yellow.png";
import SecondsEights from "../images/customisation-assets/Eight_Special.png";
import SecondsHearts from "../images/customisation-assets/Heart_Special.png";
import SecondsBee from "../images/customisation-assets/Bee_Special.png";
import SecondsLightning from "../images/customisation-assets/Lightning_Special.png";
import SecondsLuckyClover from "../images/customisation-assets/Clover_Special.png";
import SecondsPink from "../images/customisation-assets/Seconds_Pink.png";
import SecondsGreen from "../images/customisation-assets/Seconds_Green.png";

import OptionEights from "../images/customisation-option-icons/seconds_special_eights.png";
import OptionHearts from "../images/customisation-option-icons/seconds_special_hearts.png";
import OptionBee from "../images/customisation-option-icons/seconds_special_bee.png";
import OptionLightning from "../images/customisation-option-icons/seconds_special_lightning.png";
import OptionLuckyClover from "../images/customisation-option-icons/seconds_special_clover.png";

// Thumbnails
import SecondsWhiteThumb from "../images/customisation-asset-thumbnails/Seconds_White_50x50.png";
import SecondsAquaThumb from "../images/customisation-asset-thumbnails/Seconds_Aqua_50x50.png";
import SecondsBlackThumb from "../images/customisation-asset-thumbnails/Seconds_Black_50x50.png";
import SecondsBlueThumb from "../images/customisation-asset-thumbnails/Seconds_Blue_50x50.png";
import SecondsBrownThumb from "../images/customisation-asset-thumbnails/Seconds_Brown_50x50.png";
import SecondsLakeThumb from "../images/customisation-asset-thumbnails/Seconds_Lake_50x50.png";
import SecondsOrangeThumb from "../images/customisation-asset-thumbnails/Seconds_Orange_50x50.png";
import SecondsRedThumb from "../images/customisation-asset-thumbnails/Seconds_Red_50x50.png";
import SecondsYellowThumb from "../images/customisation-asset-thumbnails/Seconds_Yellow_50x50.png";
import SecondsEightsThumb from "../images/customisation-asset-thumbnails/Eight_Special_50x50.png";
import SecondsHeartsThumb from "../images/customisation-asset-thumbnails/Heart_Special_50x50.png";
import SecondsBeeThumb from "../images/customisation-asset-thumbnails/Bee_Special_50x50.png";
import SecondsLightningThumb from "../images/customisation-asset-thumbnails/Lightning_Special_50x50.png";
import SecondsLuckyCloverThumb from "../images/customisation-asset-thumbnails/Clover_Special_50x50.png";
import SecondsPinkThumb from "../images/customisation-asset-thumbnails/Seconds_Pink_50x50.png";
import SecondsGreenThumb from "../images/customisation-asset-thumbnails/Seconds_Green_50x50.png";

import { SelectionColours } from "./selection-colors";

export const SECONDS_OPTIONS = {
  white: {
    type: "standard",
    title: "White",
    watchLayerAsset: SecondsWhite,
    watchLayerThumbnail: SecondsWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.WHITE],
    },
  },
  aqua: {
    type: "standard",
    title: "Aqua",
    watchLayerAsset: SecondsAqua,
    watchLayerThumbnail: SecondsAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA],
    },
  },
  black: {
    type: "standard",
    title: "Black",
    watchLayerAsset: SecondsBlack,
    watchLayerThumbnail: SecondsBlackThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.LIGHT_BLACK],
    },
  },
  blue: {
    type: "standard",
    title: "Blue",
    watchLayerAsset: SecondsBlue,
    watchLayerThumbnail: SecondsBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLUE],
    },
  },
  brown: {
    type: "standard",
    title: "Brown",
    watchLayerAsset: SecondsBrown,
    watchLayerThumbnail: SecondsBrownThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BROWN],
    },
  },
  lake: {
    type: "standard",
    title: "Lake Green",
    watchLayerAsset: SecondsLake,
    watchLayerThumbnail: SecondsLakeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.LAKE],
    },
  },
  orange: {
    type: "standard",
    title: "Orange",
    watchLayerAsset: SecondsOrange,
    watchLayerThumbnail: SecondsOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE],
    },
  },
  red: {
    type: "standard",
    title: "Red",
    watchLayerAsset: SecondsRed,
    watchLayerThumbnail: SecondsRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED],
    },
  },
  yellow: {
    type: "standard",
    title: "Yellow",
    watchLayerAsset: SecondsYellow,
    watchLayerThumbnail: SecondsYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.YELLOW],
    },
  },
  pink: {
    type: "standard",
    title: "Pink",
    watchLayerAsset: SecondsPink,
    watchLayerThumbnail: SecondsPinkThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.PINK],
    },
  },
  green: {
    type: "standard",
    title: "Green",
    watchLayerAsset: SecondsGreen,
    watchLayerThumbnail: SecondsGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.LEAF_GREEN],
    },
  },
  eights: {
    type: "special",
    title: "Eights",
    watchLayerAsset: SecondsEights,
    watchLayerThumbnail: SecondsEightsThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionEights,
    },
  },
  hearts: {
    type: "special",
    title: "Hearts",
    watchLayerAsset: SecondsHearts,
    watchLayerThumbnail: SecondsHeartsThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionHearts,
    },
  },
  bee: {
    type: "special",
    title: "Bee",
    watchLayerAsset: SecondsBee,
    watchLayerThumbnail: SecondsBeeThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionBee,
    },
  },
  lightning: {
    type: "special",
    title: "Lightning",
    watchLayerAsset: SecondsLightning,
    watchLayerThumbnail: SecondsLightningThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionLightning,
    },
  },
  luckyClover: {
    type: "special",
    title: "Lucky Clover",
    watchLayerAsset: SecondsLuckyClover,
    watchLayerThumbnail: SecondsLuckyCloverThumb,
    selectionAsset: {
      type: "asset",
      asset: OptionLuckyClover,
    },
  },
};
